import { MedifitError } from '@meddev/fe-shared';

export class MedifitErrorDefinition {
    private static errorsMvip: { [key: string]: MedifitError } = {
        MVIP_CUSTOMER_NAME_NULL: {
            code: 'MVIP_CUSTOMER_NAME_NULL',
            msg: null,
            displayMessage: $localize`Ime je obvezen podatek.`,
        },
        MVIP_CUSTOMER_SURNAME_NULL: {
            code: 'MVIP_CUSTOMER_SURNAME_NULL',
            msg: null,
            displayMessage: $localize`Priimek je obvezen podatek.`,
        },
        MVIP_CUSTOMER_BIRTHDATE_NULL: {
            code: 'MVIP_CUSTOMER_BIRTHDATE_NULL',
            msg: null,
            displayMessage: $localize`Datum rojstva je obvezen podatek.`,
        },
        MVIP_CUSTOM_GENDER_NULL: {
            code: 'MVIP_CUSTOMER_GENDER_NULL',
            msg: null,
            displayMessage: $localize`Spol je obvezen podatek.`,
        },
    };

    private static errorsEarhiv: { [key: string]: MedifitError } = {
        EARHIV_DISABLED_CONTRACTOR: {
            code: 'EARHIV_DISABLED_CONTRACTOR',
            msg: null,
            displayMessage: $localize`Modul eArhiv je onemogočen.`,
        },
        EARHIV_CREATE_PAPER_REQUEST_ERROR: {
            code: 'EARHIV_CREATE_PAPER_REQUEST_ERROR',
            msg: null,
            displayMessage: $localize`Napaka pri shranjevanju listine v eArhiv.`,
        },
        EARHIV_CREATE_DOCUMENT_REQUEST_ERROR: {
            code: 'EARHIV_CREATE_DOCUMENT_REQUEST_ERROR',
            msg: null,
            displayMessage: $localize`Napaka pri shranjevanju dokumenta v eArhiv.`,
        },
        EARHIV_CUSTOMER_NOT_FOUND: {
            code: 'EARHIV_CUSTOMER_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Stranka ni najdena.`,
        },
        EARHIV_DOCUMENT_NOT_FOUND: {
            code: 'EARHIV_DOCUMENT_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Dokument ni najden.`,
        },
        EARHIV_CONTRACTOR_PAPER_NOT_FOUND: {
            code: 'EARHIV_CONTRACTOR_PAPER_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Listina izvajalca ni najdena.`,
        },
        MEDIFIT_DOCUMENT_NOT_FOUND: {
            code: 'MEDIFIT_DOCUMENT_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Dokument ni najden.`,
        },
        FAILED_TO_FETCH_EARHIV_METADATA_TYPES: {
            code: 'FAILED_TO_FETCH_EARHIV_METADATA_TYPES',
            msg: null,
            displayMessage: $localize`Napaka pri shranjevanju dokumenta v eArhiv.`,
        },
        EARHIV_METADATA_TYPE_NOT_FOUND: {
            code: 'EARHIV_METADATA_TYPE_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Tip metapodatka eArhiv ni najden.`,
        },
        USER_NOT_FOUND: {
            code: 'USER_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Uporabnik ni najden.`,
        },
        CONTRACTOR_NOT_FOUND: {
            code: 'CONTRACTOR_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Izvajalec ni najden.`,
        },
    };

    private static errorsCrpp: { [key: string]: MedifitError } = {
        CERTIFICATE_ERROR: {
            code: 'CERTIFICATE_ERROR',
            msg: null,
            displayMessage: $localize`Napaka pri pridobivanju certifikata.`,
        },
        SAML_TOKEN_ERROR: {
            code: 'SAML_TOKEN_ERROR',
            msg: null,
            displayMessage: $localize`Napaka pri pridobivanju SAML žetona.`,
        },
        CONSENT_VALIDATION_DOCUMENT_ACCESS: {
            code: 'CONSENT_VALIDATION_DOCUMENT_ACCESS',
            msg: null,
            displayMessage: $localize`Veljavna privolitev za dostop do rezervacije ni bila najdena.`,
        },
        REVOKED_DOCUMENT_NOT_FOUND: {
            code: 'REVOKED_DOCUMENT_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Preklicana listina ni bila najdena.`,
        },
        DOCUMENT_HANDLE_NOT_FOUND: {
            code: 'DOCUMENT_HANDLE_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Dokument ni bil najden.`,
        },
        RESERVATION_DOCUMENT_ALREADY_EXISTS: {
            code: 'RESERVATION_DOCUMENT_ALREADY_EXISTS',
            msg: null,
            displayMessage: $localize`Listina je že objavljena v CRPP.`,
        },
        RESERVATION_DOCUMENT_NOT_FOUND: {
            code: 'RESERVATION_DOCUMENT_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Listina rezervacije ni bila najdena v CRPP.`,
        },
        USER_REGISTERED_NOT_FOUND: {
            code: 'USER_REGISTERED_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Registriran uporabnik ni bil najden.`,
        },
        INACTIVE_RESERVATION: {
            code: 'INACTIVE_RESERVATION',
            msg: null,
            displayMessage: $localize`Datum rezervacije ni več aktiven.`,
        },
        CONSENT_INACTIVE: {
            code: 'CONSENT_INACTIVE',
            msg: null,
            displayMessage: $localize`Privolitev ni več aktivna.`,
        },
        CONSENT_INVALID_CONTRACTOR: {
            code: 'CONSENT_INVALID_CONTRACTOR',
            msg: null,
            displayMessage: $localize`Privolitev ni veljavna za tega izvajalca.`,
        },
        CONSENT_NOT_FOUND: {
            code: 'CONSENT_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Privolitev ni bila najdena.`,
        },
        CONSENT_ALREADY_SYNCED: {
            code: 'CONSENT_ALREADY_SYNCED',
            msg: null,
            displayMessage: $localize`Privolitev je že sinhronizirana.`,
        },
        CONSENT_CANCEL_INVALID_STATUS: {
            code: 'CONSENT_CANCEL_INVALID_STATUS',
            msg: null,
            displayMessage: $localize`Preklica privolitve ni mogoče izvesti zaradi neveljavenega statusa.`,
        },
        FAILED_TO_STORE_CONSENT: {
            code: 'FAILED_TO_STORE_CONSENT',
            msg: null,
            displayMessage: $localize`Napaka pri shranjevanju privolitve.`,
        },
        FAILED_TO_REVOKE_CONSENT: {
            code: 'FAILED_TO_REVOKE_CONSENT',
            msg: null,
            displayMessage: $localize`Napaka pri preklicu privolitve.`,
        },
        FAILED_TO_STORE_DOCUMENT: {
            code: 'FAILED_TO_STORE_DOCUMENT',
            msg: null,
            displayMessage: $localize`Napaka pri shranjevanju listine v CRPP.`,
        },
        FAILED_TO_REVOKE_DOCUMENT: {
            code: 'FAILED_TO_REVOKE_DOCUMENT',
            msg: null,
            displayMessage: $localize`Napaka pri preklicu listine v CRPP.`,
        },
        FAILED_TO_REPLACE_DOCUMENT: {
            code: 'FAILED_TO_REPLACE_DOCUMENT',
            msg: null,
            displayMessage: $localize`Napaka pri zamenjavi listine v CRPP.`,
        },
        FAILED_TO_GET_ACCESS_TOKEN: {
            code: 'FAILED_TO_GET_ACCESS_TOKEN',
            msg: null,
            displayMessage: $localize`Napaka pri pridobivanju dostopnega žetona.`,
        },
    };

    private static errorsBooking: { [key: string]: MedifitError } = {
        SERVICE_ON_ACTIVE_BS_PRICE: {
            code: 'SERVICE_ON_ACTIVE_BS_PRICE',
            msg: null,
            displayMessage: $localize`Storitev je prisotna v aktivnem ceniku partnerja.`,
        },
        SERVICE_CANNOT_BE_DELETED: {
            code: 'SERVICE_CANNOT_BE_DELETED',
            msg: null,
            displayMessage: $localize`Storitev je povezana s partnerjem in je ni mogoče izbrisati.`,
        },
        SERVICE_HAS_FUTURE_RESERVATIONS: {
            code: 'SERVICE_HAS_FUTURE_RESERVATIONS',
            msg: null,
            displayMessage: $localize`Storitev obstaja v prihajajočem terminu.`,
        },
    };

    public static errors: { [key: string]: MedifitError } = {
        ...MedifitErrorDefinition.errorsMvip,
        ...MedifitErrorDefinition.errorsEarhiv,
        ...MedifitErrorDefinition.errorsCrpp,
        ...MedifitErrorDefinition.errorsBooking,
    };
}
